import { jsx as r, jsxs as O } from "../../_virtual/jsx-runtime.mjs";
import * as a from "react";
import { inputIcon as p, inputFix as E, inputLabel as Y, clearIcon as Z, reoInput as _, inputWrap as $, inputDisabled as ll, focused as al, inputError as ol, inputWarning as sl, inputSuccess as il, sizeStyle as nl, inputContainer as rl, required as cl } from "./css/ReoInput.mjs";
import c from "../../depend/classnames/index.mjs";
import { suffixPx as d } from "../../utils/suffixPx.mjs";
import { getValByDef as t } from "../../utils/getValByDef.mjs";
import { omitProps as tl, defaultInputProps as P } from "./const.mjs";
import C from "../ReoIcon/ReoIcon.mjs";
import { useOmitProps as ul } from "../../hook/useOmitProps.mjs";
import { useCurrentStatus as el } from "../../hook/useCurrentStatus.mjs";
import ml from "./Info.mjs";
import { useTheme as pl } from "../../hook/useTheme.mjs";
import { EThemeTemplate as dl } from "../../common/type.mjs";
const Cl = a.forwardRef((l, B) => {
  const R = ul(l, tl), [f, e] = a.useState(""), s = a.useMemo(() => l.value ?? f, [l.value, f]), h = pl({ theme: l.theme, template: dl.INPUT }), b = a.useMemo(() => t(l.size, P.size), [l.size]), m = a.useRef(null), u = el(l);
  a.useImperativeHandle(B, () => m.current, []);
  const [v, N] = a.useState(!1), T = a.useCallback(() => {
    var o;
    N(!0), (o = m.current) == null || o.focus();
  }, []), q = a.useCallback((o) => {
    var i, n;
    l.trim !== !1 && (e(s.trim()), (i = l.onChange) == null || i.call(l, s.trim())), (n = l.onBlur) == null || n.call(l, o), N(!1);
  }, [s, l]), z = a.useCallback((o) => {
    var i, n;
    o.key === "Enter" && ((i = l.onEnter) == null || i.call(l, s), (n = l.onSearch) == null || n.call(l, s));
  }, [s, l]), k = a.useCallback((o) => l != null && l.encodeHTML ? l.encodeHTML(o) : o.replace(/</g, "&lt;").replace(/>/g, "&gt;"), [l]), D = a.useCallback((o) => {
    var i, n;
    if (l != null && l.shouldEscape) {
      const X = k(o.target.value);
      (i = l.onChange) == null || i.call(l, X);
    } else
      (n = l.onChange) == null || n.call(l, o.target.value);
    e(o.target.value);
  }, [k, l]), x = a.useCallback((o) => {
    var i, n;
    o.stopPropagation(), (i = l.iconOnClick) == null || i.call(l, s), (n = l.onSearch) == null || n.call(l, s);
  }, [s, l]), H = a.useCallback((o) => /* @__PURE__ */ r(
    C,
    {
      className: c(p, l.iconClassName),
      style: o,
      spin: !0,
      name: "icon-icon-loading-1",
      width: d(t(l.iconWidth ?? "", "var(--icon-width)"))
    }
  ), [l.iconClassName, l.iconWidth]), g = a.useMemo(
    () => !!(l.iconOnClick ?? l.onSearch),
    [l.iconOnClick, l.onSearch]
  ), y = a.useMemo(
    () => l.icon ? /* @__PURE__ */ r(
      C,
      {
        className: c(p, l.iconClassName),
        name: l.icon,
        width: d(t(l.iconWidth ?? "", "var(--icon-width)")),
        onClick: x,
        style: {
          cursor: g ? "pointer" : "auto"
        }
      }
    ) : null,
    [x, g, l.icon, l.iconClassName, l.iconWidth]
  ), M = a.useCallback(() => {
    var o, i;
    (o = l.suffixOnClick) == null || o.call(l, s), (i = l.onSearch) == null || i.call(l, s);
  }, [s, l]), S = a.useMemo(
    () => !!(l.suffixOnClick ?? l.onSearch),
    [l.onSearch, l.suffixOnClick]
  ), L = a.useMemo(
    () => l.suffix ? /* @__PURE__ */ r(
      "div",
      {
        onClick: M,
        className: c(E.suffix, l.suffixClassName),
        style: {
          cursor: S ? "pointer" : "auto"
        },
        children: l.suffix
      }
    ) : y,
    [M, y, l.suffix, l.suffixClassName, S]
  ), w = a.useCallback(() => {
    var o;
    (o = l.prefixOnClick) == null || o.call(l, s);
  }, [s, l]), j = a.useMemo(() => l.prefix ? /* @__PURE__ */ r(
    "div",
    {
      onClick: w,
      className: c(E.prefix, l.prefixClassName),
      children: l.prefix
    }
  ) : null, [w, l.prefix, l.prefixClassName]), F = a.useMemo(() => l.label ? /* @__PURE__ */ r(
    "div",
    {
      className: Y,
      children: /* @__PURE__ */ r(
        "label",
        {
          htmlFor: l.id,
          children: l.label
        }
      )
    }
  ) : null, [l.id, l.label]), I = a.useCallback(() => {
    var o, i;
    e(""), (o = l.onChange) == null || o.call(l, ""), (i = l.onClear) == null || i.call(l);
  }, [l]), W = a.useMemo(() => l.allowClear !== !1, [l.allowClear]), K = a.useMemo(
    () => W && s ? /* @__PURE__ */ r(
      C,
      {
        className: c(p, Z, l.iconClassName),
        name: "icon-icon-hint-error",
        width: d(t(l.iconWidth ?? "", "var(--icon-width)")),
        onClick: I
      }
    ) : null,
    [I, s, W, l.iconClassName, l.iconWidth]
  ), U = a.useMemo(
    () => c(
      _,
      "reo-basic-input",
      l.inputClassName
    ),
    [l.inputClassName]
  ), V = a.useMemo(() => ({
    ...l.inputStyle
  }), [l.inputStyle]), A = a.useMemo(
    () => c(
      h,
      $,
      l.disabled ? ll : null,
      v ? al : null,
      u === "error" ? ol : null,
      u === "warning" ? sl : null,
      u === "success" ? il : null,
      nl[b],
      "reo-basic-input-wrap",
      l.className
    ),
    [u, v, l.className, l.disabled, b, h]
  ), G = a.useMemo(
    () => ({
      "--placeholder-color": l.placeholderColor,
      "--color": l.color,
      "--border-color": l.borderColor,
      "--active-color": l.activeBorderColor,
      "--background-color": l.backgroundColor,
      ...l.style
    }),
    [
      l.activeBorderColor,
      l.backgroundColor,
      l.borderColor,
      l.color,
      l.placeholderColor,
      l.style
    ]
  ), J = a.useMemo(() => c(
    rl,
    l.showRequired ? cl : null,
    "reo-basic-input-container",
    l.containerClassName
  ), [l.containerClassName, l.showRequired]), Q = a.useMemo(
    () => ({
      ...l.containerStyle
    }),
    [l.containerStyle]
  );
  return /* @__PURE__ */ O(
    "div",
    {
      className: A,
      style: G,
      onClick: T,
      children: [
        F,
        /* @__PURE__ */ O(
          "div",
          {
            className: J,
            style: Q,
            children: [
              j,
              /* @__PURE__ */ r(
                "input",
                {
                  onKeyDown: z,
                  onBlur: q,
                  ref: m,
                  className: U,
                  style: V,
                  id: l.id,
                  onChange: D,
                  disabled: l.disabled,
                  placeholder: l.placeholder,
                  value: s,
                  type: t(l.type, P.type),
                  ...R
                }
              ),
              l.loading ? H() : K,
              L
            ]
          }
        ),
        /* @__PURE__ */ r(ml, { children: l.infoMessage })
      ]
    }
  );
});
Cl.displayName = "ReoInput";
export {
  Cl as default
};
//# sourceMappingURL=ReoInput.mjs.map
